import { Component, EventEmitter, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';

@Component({
  selector: 'app-edit-icon-button',
  standalone: false,
  templateUrl: './edit-icon-button.component.html',
})
export class EditIconButtonComponent extends AppBaseComponent {
  @Output() triggered = new EventEmitter<void>();

  onClick(): void {
    this.triggered.emit();
  }
}
